<template>
  <div>
    <div class="chat-token--attributes" v-if="attributes">
      <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
        <swiper-slide>
          <div class="attributes-wrapper"  >
            <div class="attributes-token"  v-for="(value, key) in attributes" :key="key" v-if="key">
              <span  >
                <span style="text-transform: capitalize">{{key}}:</span>
                <span>{{ value }}</span>
              </span>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="custom-swiper-navigation">
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "chatAttributes",
    props: {
      attributes:{
        type: Object,
        default: ()=>{
          return {}
        }
      }
    },
    data(){
      return {
        swiperOptions: {
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        },
      }
    },
    methods: {
      formatAttributes(attributes) {
        let attributesArr = Object.keys(attributes).map(key=>{
          return {name:key,value:attributes[key] }
        })
        return attributesArr
      }
    }
  }
</script>

<style scoped>

</style>
